import { Injectable } from '@angular/core';
import { FormGroup, AbstractControl } from '@angular/forms';
import { AppAlertService } from './alert.service';

@Injectable({ providedIn: 'root' })
export class FormValidationService {

    constructor(private alert: AppAlertService) {}

    /**
     * Valida campos requeridos de un formulario y muestra alertas automáticamente.
     * @param form FormGroup a validar
     * @param fieldNames Objeto con key=nombreControl, value=nombre para mostrar en alerta
     * @returns true si todos los campos son válidos, false si hay errores
     */
    validateRequiredFields(form: FormGroup, fieldNames: Record<string, string>): boolean {
        let isValid = true;

        Object.keys(fieldNames).forEach(key => {
            const control: AbstractControl | null = form.get(key);
            if (!control?.value) {
                control?.markAsTouched();
                control?.setErrors({ required: true });
                this.alert.error(`El campo "${fieldNames[key]}" es obligatorio.`);
                isValid = false;
            }
        });

        return isValid;
    }

    /**
     * Valida un solo campo de forma individual (opcional)
     */
    validateField(form: FormGroup, controlName: string, label: string): boolean {
        const control = form.get(controlName);
        if (!control?.value) {
            control?.markAsTouched();
            control?.setErrors({ required: true });
            this.alert.error(`El campo "${label}" es obligatorio.`);
            return false;
        }
        return true;
    }

    /**
     * Valida campos de tipo autocomplete verificando que el valor exista en la lista de opciones
     * @param form FormGroup a validar
     * @param fieldConfigs Array de objetos { controlName, list, label }
     * @returns true si todos son válidos, false si hay errores
     */
    validateAutocompleteFields(form: FormGroup, fieldConfigs: { controlName: string, list: any[], label: string, optional?: boolean }[]): boolean {
        let isValid = true;

        fieldConfigs.forEach(field => {
            const control = form.get(field.controlName);
            const value = control?.value;

            if ((!value && !field.optional) || (value && !field.list.find(item => item.id === value?.id))) {
                control?.markAsTouched();
                control?.setErrors({ required: true });
                this.alert.error(`Seleccione un ${field.label} válido.`);
                isValid = false;
            }
        });

        return isValid;
    }
}
